import { styled } from "@vitality-ds/system";
import BaseDialogContainerStyles from "./styles/BaseDialogContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDialogContainer = styled("div", BaseDialogContainerStyles);